export type LoadingStep =
  | 'idle'
  | 'reserving-vm'
  | 'connecting'
  | 'authenticating'
  | 'loading-model'
  | 'initializing-scene'

export const LOADING_STEP_ORDER: ReadonlyArray<LoadingStep> = [
  'idle',
  'reserving-vm',
  'connecting',
  'authenticating',
  'loading-model',
  'initializing-scene',
]

export type DisplayableLoadingStep = Exclude<LoadingStep, 'idle'>

export const LOADING_STEP_LABELS: Readonly<
  Record<DisplayableLoadingStep, string>
> = {
  'reserving-vm': 'Reserving VM',
  connecting: 'Connecting to Stream',
  authenticating: 'Authenticating',
  'loading-model': 'Loading Model',
  'initializing-scene': 'Initializing Scene',
}
